import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * Showcase a single featured project — image on one side, copy on the other.
 * Used on Real Estate Partner, Residential, and Commercial pages.
 */
export default function FeaturedProject({
    eyebrow = "Featured Project",
    title,
    location = "",
    description,
    image,
    cta = { label: "Start a Similar Project", to: "/contact" },
    reverse = false,
    testId = "featured-project",
}) {
    return (
        <div
            data-testid={testId}
            className={`grid grid-cols-1 lg:grid-cols-12 gap-px bg-white/10 border border-white/10`}
        >
            <div
                className={`lg:col-span-7 bg-[#0A0A0A] ${reverse ? "lg:order-2" : ""}`}
            >
                <div className="relative aspect-[16/10] lg:aspect-auto lg:h-full overflow-hidden">
                    <img
                        src={image}
                        alt={title}
                        className="w-full h-full object-cover"
                    />
                </div>
            </div>
            <div className="lg:col-span-5 bg-[#0A0A0A] p-8 md:p-12 flex flex-col justify-center">
                <span className="overline">{eyebrow}</span>
                <h3 className="font-display text-3xl md:text-4xl text-white mt-4 leading-tight">
                    {title}
                </h3>
                {location && (
                    <p className="text-xs uppercase tracking-[0.2em] text-white/45 mt-3">
                        {location}
                    </p>
                )}
                <p className="text-white/60 mt-5 leading-relaxed">
                    {description}
                </p>
                <Link
                    to={cta.to}
                    className="btn-primary mt-8 w-fit"
                    data-testid={`${testId}-cta`}
                >
                    {cta.label} <ArrowRight size={14} />
                </Link>
            </div>
        </div>
    );
}
